exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-input-wrapper .same-as-checkbox{margin-left:340px;font-size:80%}", ""]);

// exports
